import { useMemo, useCallback } from 'react';
import { isIframe, resolveAllowedParentOrigin } from '../utils';
const usePostMessage = allowedOrigins => {
  var _allowedOrigins$;
  const fallbackOrigin = (_allowedOrigins$ = allowedOrigins[0]) !== null && _allowedOrigins$ !== void 0 ? _allowedOrigins$ : window.location.origin;
  const origin = useMemo(() => {
    var _window$location$ance;
    return resolveAllowedParentOrigin(allowedOrigins, [(_window$location$ance = window.location.ancestorOrigins) === null || _window$location$ance === void 0 ? void 0 : _window$location$ance[0], document.referrer], fallbackOrigin);
  }, [allowedOrigins, fallbackOrigin]);
  const postMessage = useCallback((key, value) => {
    if (isIframe()) {
      window.parent.postMessage({
        message: key,
        value
      }, origin);
    }
  }, [origin]);
  return useMemo(() => {
    return {
      allowedParentOrigin: origin,
      allowedParentOrigins: allowedOrigins,
      postMessage,
      postExpandMessage: expand => postMessage('expand', expand),
      postLocaleMessage: locale => postMessage('locale', locale)
    };
  }, [postMessage, origin, allowedOrigins]);
};
export default usePostMessage;